import { Entity } from "../helpers/Entity"
import ExternalLink from "../integration/ExternalLink"

export type SchedulingPageAttributesDto = {
    seller: object,
    sellerId: string,
    locationId: string,
    location: object,
    sendSchedulingPageEmailTemplateId: string,
    sendSchedulingPageEmailSubject: string,
    sendSchedulingPageEmailContent: string,
    sendSchedulingPageEmailButtonLabel: string,
    sendSchedulingPageFromEmailAddress: string,
    sendSchedulingPageFromName: string,
    emailTemplateId: string,
    emailSubject: string,
    emailContent: string,
    fromEmailAddress: string,
    fromName: string,
    activatedAt: string,
    deactivatedAt: string,
    activatedBy: string,
    title: string,
    status: string,
    proposalHash: string,
    urlLink: string,
    externalLinks: ExternalLink[],
    calendars: object[],
    identifierId: string,
    identifier: string,
    accountId: string,
    createdAt: string,
    createdBy: string,
    updatedBy: string,
    updatedAt: string,
    deletedBy: string,
    deletedAt: string,
    availableFrom: string[],
    contactCustomFieldIds: string[],
}

export type SchedulingPageDto = {
    id: string
    type: string
    attributes: SchedulingPageAttributesDto
}

export default class SchedulingPage implements Entity {
    private dto: SchedulingPageDto

    constructor(dto: SchedulingPageDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "scheduling-pages"
    }

    getId(): string {
        return this.dto.id
    }

    getAvailableFrom(): string[] {
        return this.dto.attributes.availableFrom
    }

    getContactCustomFieldIds(): string[] {
        return this.dto.attributes.contactCustomFieldIds
    }

    getExternalLinks(): ExternalLink[] {
        return this.dto.attributes.externalLinks ?? []
    }
}


// WEBPACK FOOTER //
// ./src/state/scheduling-page/SchedulingPage.ts